"use client";

import EditIcon from "@mui/icons-material/Edit";
import { Menu } from "@mui/material";
import React from "react";
import { useNavigate } from "react-router-dom";

import { LIST_PRICE_PERMISSIONS } from "@/constants/modules.permissions";
import ROUTE_URLS from "@/constants/route-urls";
import useAuth from "@/contexts/auth-context";
import useLanguage from "@/contexts/language-context";
import { IListPrice } from "@/interfaces/list-price.interface";
import { ListPriceMessages } from "@/messages/listPrice/list-price.messages";
import NotificationItem from "@/mui/Items/NotificationItem";

interface Props {
  isOpen: boolean;
  anchorEl: (EventTarget & HTMLButtonElement) | null;
  onClose: () => void;
  messages: ListPriceMessages;
  selected: IListPrice;
}

export function ListPricePopover({ isOpen, anchorEl, onClose, messages, selected }: Props) {
  const router = useNavigate();
  const { lang } = useLanguage();
  const { checkPermissions } = useAuth();
  const hasNoPermissionToEdit = checkPermissions(LIST_PRICE_PERMISSIONS.EDIT);

  return (
    <Menu
      open={isOpen}
      anchorEl={anchorEl}
      onClose={onClose}
      anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
    >
      <NotificationItem
        icon={<EditIcon />}
        disabled={hasNoPermissionToEdit}
        onClick={() => router(ROUTE_URLS.updateListPrice(lang, selected.id))}
        title={messages.updatePopover}
      />
    </Menu>
  );
}
